<script>
  import { formatFileSize } from "../../../../utils/files.js";

  let { value, skeleton = false } = $props();
</script>

{#if skeleton}
  <span class:skeleton>Loading...</span>
{:else}
  <div>
    {formatFileSize(value)}
  </div>
{/if}
